import { type Timestamp } from '../services/Timestamp';

export const HttpMethods = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

export const HttpHeaders = {
  contentTypeJson: { 'Content-Type': 'application/json' },
  acceptJson: { Accept: 'application/json' },
};

export const getBearerToken = (token: string): string => `Bearer ${token}`;

export const ApiEndpoints = {
  rateApp: {
    addEventCount: '/api/rateApp/addEventCount',
    userLogin: '/api/rateApp/userLogin',
    resetRating: '/api/rateApp/resetRating',
  },
  trips: {
    getTripsPaginated: (pageNumber: number, limit: number, queryString: string) =>
      `/api/trips/paginated/${pageNumber}/${limit}?${queryString}`,
    getEcoRatings: (queryString: string) => `/api/trips/eco-rating?${queryString}`,
    getJobVesselTracks: (operation: string, tripId: string, jobId: string) =>
      `/api/trips/${operation}/${tripId}/jobs/${jobId}/vessel-tracks`,
  },
  liveview: {
    getLiveviewData: (operation: string) => `/api/liveview/${operation}`,
    getVesselTracks: (operation: string, mmsi: string) => `/api/liveview/tracks/${operation}/${mmsi}`,
  },
  getPlaybackData: (operation: string, from: number, to: number) => `/api/playback/${operation}/${from}/${to}`,
  tides: {
    getTides: (id: string) => `/api/tides/${id}`,
    getTideInfo: (operation: string, timestamp: Timestamp) => `/api/tides/info/${operation}/${timestamp.toSeconds()}`,
  },
  operations: `/api/operations/`,
  getSecrets: (secretName: string) => `/api/secrets/${secretName}`,
  settings: '/api/settings',
  vessels: '/api/vessels/',
  search: {
    getTripsOrJobs: (searchFilter: string) => {
      if (searchFilter) {
        return `/api/search/trips?${searchFilter}`;
      }

      return '/api/search/trips';
    },
    getVessels: (searchFilter: string) => {
      if (searchFilter) {
        return `/api/search/vessels?${searchFilter}`;
      }

      return '/api/search/vessels';
    },
    getOperations: (searchFilter: string) => {
      if (searchFilter) {
        return `/api/search/operations?${searchFilter}`;
      }

      return '/api/search/operations';
    },
  },
};
